import { createContext, useEffect, useState, useSyncExternalStore } from 'react';

import type { ReactNode } from 'react';

import type { HubConnection, HubConnectionState } from '@microsoft/signalr';

import {
  connectSignalR,
  disconnectSignalR,
  getStateSnapshot,
  signalRConnection,
  subscribeStateChange
} from './signalRConnection';

export const SignalRConnectionContext = createContext<{
  connection: HubConnection;
  state: HubConnectionState;
  // @ts-ignore
}>(null);

export const SignalRConnectionContextProvider = ({ children }: { children: ReactNode }) => {
  const state = useSyncExternalStore(subscribeStateChange, getStateSnapshot);
  const [value, setValue] = useState({ connection: signalRConnection, state });

  useEffect(() => {
    setValue({ connection: signalRConnection, state });
  }, [state]);

  useEffect(() => {
    connectSignalR();

    return () => {
      disconnectSignalR();
    };
  }, []);

  return (
    <SignalRConnectionContext.Provider value={value}>{children}</SignalRConnectionContext.Provider>
  );
};
